import { getInvoiceByIdQuery, updatePoMutation } from '../util/graphQL';
import { navigateInvoiceDetails, navigateToPayment } from './stepper-actions';
import { navigateTo } from '../util/navigation';
import { setPaymentAmount } from './payment-actions';
import actionTypes from '../constants/action-types';
import paymentTypes from '../constants/payment-type-constants';
import status from '../constants/invoice-status';

export const updateInvoice = (invoice) => (dispatch) =>
  dispatch({
    type: actionTypes.GET_INVOICE_SUCCESS,
    invoice,
  });

export const getInvoiceSuccess =
  (invoice, errors = null) =>
  (dispatch) => {
    if (invoice === null) {
      // For now, only get the first error
      const errorMessage = errors
        ? errors[0].Message
        : 'Invalid invoice number or payment code.';
      throw new Error(errorMessage);
    } else if (invoice && invoice.creditCard.ccDisplay === null) {
      // No card on file, default payment type to New Card
      dispatch({
        type: actionTypes.UPDATE_PAYMENT_TYPE,
        paymentType: paymentTypes.NEW,
      });
    }

    if (
      invoice &&
      (invoice.invoiceStatusName === status.AWAITING ||
        invoice.invoiceStatusName === status.PARTIAL ||
        invoice.invoiceStatusName === status.PAID)
    ) {
      Promise.all([
        dispatch(updateInvoice(invoice)),
        dispatch(setPaymentAmount(invoice.balanceDue)),
        dispatch(navigateInvoiceDetails()),
      ]).then(navigateTo('/invoice'));
    } else {
      // TODO: Check for statuses other than processing
      const errorMessage =
        'Invoice is processing. Please try again in a few minutes.';
      throw new Error(errorMessage);
    }
  };

export const getInvoiceError = (error) => (dispatch) =>
  dispatch({
    type: actionTypes.GET_INVOICE_ERROR,
    error,
  });

export const getInvoiceById = (invoiceId, paymentCode) => (dispatch) => {
  // Call graphQL endpoint
  dispatch({
    type: actionTypes.GET_INVOICE_REQUEST,
  });

  getInvoiceByIdQuery(invoiceId, paymentCode)
    .then((response) => {
      const { data, errors } = response;
      const invoice = data.getInvoice;
      dispatch(getInvoiceSuccess(invoice, errors));
    })
    .catch((error) => {
      dispatch(getInvoiceError(error.message));
    });
};

export const submit = () => (dispatch) => {
  dispatch(navigateToPayment());
};

export const openPoNumberEdit = () => (dispatch) => {
  dispatch({
    type: actionTypes.INVOICE_OPEN_EDIT,
  });
};

export const closePoNumberEdit = () => (dispatch) => {
  dispatch({
    type: actionTypes.INVOICE_CLOSE_EDIT,
  });
};

export const updatePoSuccess = (poNumber) => (dispatch) => {
  dispatch({
    type: actionTypes.POST_PO_SUCCESS,
    poNumber,
  });
};

export const updatePoError = (error) => (dispatch) => {
  dispatch({
    type: actionTypes.POST_PO_ERROR,
    error,
  });
};

export const updatePoNumber = (poNumber) => (dispatch, getState) => {
  const { invoice } = getState();
  const { invoiceId, paymentCode, additionalNotes } = invoice;

  dispatch({
    type: actionTypes.POST_PO_REQUEST,
  });

  // Addtional Notes must be sent when updating PO number so that they are not cleared
  updatePoMutation(invoiceId, paymentCode, poNumber, additionalNotes)
    .then((res) => {
      const { data } = res;
      const updatedInvoice = data.editInvoice;

      if (updatedInvoice) {
        // Successfully updated poNumber, go ahead and update state tree
        dispatch(updatePoSuccess(updatedInvoice.poNumber));
        dispatch(closePoNumberEdit());
      } else {
        // Handle error
        //  const errorMessage = errors[0].Message;

        const errorMessage = 'Error occured';
        throw new Error(errorMessage);
      }
    })
    .catch((error) => {
      dispatch(updatePoError(error.message));
    });
};
